import { hasAccess } from '@/lib/services/account_license_level';
import { Home } from '../components/main-page/Home';
import {
  fetchApplicant,
  fetchChildCompaniesLogo,
  fetchCompanyCustomization,
  fetchCompanyIdByHost,
  getHost,
  getOpeningJobs,
} from '@/lib/services/server_side_props';

export default function Index({
  jobs,
  company,
  company_type,
  applicant,
  child_companies_logo,
  company_page_url,
}) {
  return (
    <Home
      jobs={jobs}
      company={company}
      photoPath={applicant?.f_photo?.url}
      child_companies_logo={child_companies_logo}
      style={{
        '--color-primary': company?.primary_color,
        '--color-secondary': company?.secondary_color,
      }}
      type={company_type}
      company_page_url={company_page_url}
    />
  );
}

// This gets called on every request
export async function getServerSideProps(context) {
  const { req, query, res, asPath, pathname } = context;

  try {
    if (req) {
      let host = getHost(req);
      let company_page_url;

      const {
        id: company_id,
        name: company_name,
        partner_id,
        company_customization,
        account_license_level,
        type,
      } = await fetchCompanyIdByHost(host);

      if (!company_id) {
        return { notFound: true };
      }

      if (!hasAccess('business', account_license_level, type)) {
        return { notFound: true };
      }

      const { base_domain, domain_prefix } = await fetchCompanyCustomization(company_id);
      
      company_page_url = `${domain_prefix}.${base_domain}`;
      const currentHost = host.replace(/^https?:\/\//, '');

      if (currentHost !== company_page_url) {
        return {
          redirect: {
            destination: `https://${company_page_url}`,
            permanent: true,
          },
        };
      }

      const applicant = await fetchApplicant(req);
      const jobs = await getOpeningJobs(company_id);
      const filtered_jobs = jobs.filter((job) => !job.finished_at);
      const child_companies_logo = await fetchChildCompaniesLogo(company_id);

      return {
        props: {
          jobs: filtered_jobs,
          company: { ...company_customization, name: company_name },
          company_type: type,
          applicant,
          child_companies_logo,
          company_page_url,
        },
      };
    }
  } catch (error) {
    console.error(error.message);
  }

  return { notFound: true };
}
